import { parseAsStringLiteral, useQueryState } from 'nuqs';

export const LOGS_VIEW_VALUES = ['pipeline', 'agent'] as const;
export type LogsView = (typeof LOGS_VIEW_VALUES)[number];

export const DEFAULT_LOGS_VIEW: LogsView = 'pipeline';

export function useLogsViewUrlState() {
  const [logsView, setLogsView] = useQueryState(
    'logsView',
    parseAsStringLiteral(LOGS_VIEW_VALUES).withDefault(DEFAULT_LOGS_VIEW)
  );

  return { logsView, setLogsView };
}
